// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"a1bc96de","584":"e50f25df","606":"f456c69f","688":"0f9b617e"}[chunkId] + ".chunk.js";
};